function r(r){const s=this;if(s.support.touch||!s.params.simulateTouch||s.params.watchOverflow&&s.isLocked||s.params.cssMode)return;const a="container"===s.params.touchEventsTarget?s.el:s.wrapperEl;a.style.cursor="move",a.style.cursor=r?"grabbing":"grab"}export{r as default};
//# sourceMappingURL=setGrabCursor.js.map
